import { defineComponent, useAttrs ,computed} from 'vue'
import { createNameSpace } from '@el-plus/utils/bem'
import { useFormItemRules, useFormItemSlots } from './hooks/use-form-item'
import { ElFormItem } from 'element-plus'

import { formItemProps, expandFormItemPropsKeys } from './form-item'
import {
  prepareProps,
  prepareEvents,
  prepareClassNames,
  prepareStyles,
} from '@el-plus/utils/props'
const bem = createNameSpace('form-item')
export default defineComponent({
  name: 'EpFormItem',
  inheritAttrs: false,
  props: formItemProps,
  setup(props, { emit }) {
    // const {} = useFormItem(props)
    const attrs = useAttrs()
    const { scopedSlots } = useFormItemSlots(props,emit)
    const { rules } = useFormItemRules(props)
    const { props: childProps, disabled, ...formItemProps } = props // eslint-disable-line
    const isShowLabel = computed(() =>{
      if(!props.label) return false
      return props.isShowLabel
    })
    return () => {
      return (
        <ElFormItem
          class={[
            bem.b(),
            bem.is('hide-label', !isShowLabel.value),
            prepareClassNames(),
          ]}
          style={prepareStyles()}
          v-slots={scopedSlots}
          {...{
            ...prepareProps(formItemProps, [...expandFormItemPropsKeys]),
            rules,
            'label-width': attrs['form-label-width'],
          }}
          // scopedSlots={scopedSlots}
          // label={label}
          // prop={prop}
          // rules={mergeRules}
          // {...{ props: formItemProps }}
        />
      )
    }
  },
})
